import React from 'react';
import BaseTextTicker from 'react-native-text-ticker';
import { withTheme } from '@rneui/themed';
import { Platform, Text } from 'react-native';
export const UnthemedTextTicker = ({ children, bold, numberOfLines, ellipsizeMode, ...props }) => {
    if (Platform.OS === 'web') {
        return (React.createElement(Text, { style: props.style, numberOfLines: 1, ellipsizeMode: "tail" }, children));
    }
    return (React.createElement(BaseTextTicker, { ...props }, children));
};
export const TextTicker = withTheme(UnthemedTextTicker, 'TextTicker');
//# sourceMappingURL=TextTicker.js.map